import Component from '@glimmer/component';
import { VStack } from 'tio-ui/components/layout';
import { Heading, Text } from 'tio-ui/components/typography';
import PageHero from 'tio-reimagined/components/page-hero';
import { PhClockCounterClockwise } from 'ember-phosphor-icons';

interface HistorySignature {
  Args: {
    model: unknown;
  };
}

export default class CareerPathwaysFinanceHistory extends Component<HistorySignature> {
  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="data-audit w-full min-w-0">
      <PageHero @theme="gray">
        <:icon>
          <PhClockCounterClockwise @size={{28}} />
          <Heading @level={{1}} class="text-white text-2xl">Allocation History</Heading>
        </:icon>
        <:default>
          <Text class="text-gray-100 text-lg">
            Track your Section 127 benefit usage over time.
          </Text>
        </:default>
      </PageHero>

      <div class="bg-white rounded-lg p-8 shadow-sm ring-1 ring-gray-950/[0.04] text-center">
        <div
          class="p-4 bg-gray-50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center"
        >
          <PhClockCounterClockwise @size={{40}} class="text-gray-600" />
        </div>
        <Heading @level={{2}} class="text-xl font-semibold text-gray-900 mb-2">History Coming Soon</Heading>
        <Text @intent="muted" class="max-w-md mx-auto">
          View your past allocations, employer contributions, and track how your Section 127 benefit
          has helped you pay down loans and invest in education over time.
        </Text>
      </div>
    </VStack>
  </template>
}
